import React from 'react';
import { isSmartLightEmployee } from '../authUtils';
import { ShieldAlert } from 'lucide-react';

/**
 * ProtectedRoute - Route guard for internal SmartLight employee-only pages
 * 
 * This component ensures that only authenticated SmartLight employees
 * can access certain routes like the Integrations page.
 * 
 * Non-internal users will see an access denied message in the main content area
 * while remaining in the AppShell (so they still see the sidebar).
 */
function ProtectedRoute({ children }) {
  if (!isSmartLightEmployee()) {
    // Show access denied message inline (within AppShell)
    return (
      <div className="flex h-full items-center justify-center p-6">
        <div className="w-full max-w-md space-y-6 text-center">
          <div className="flex justify-center">
            <div className="rounded-full bg-destructive/10 p-6">
              <ShieldAlert className="h-16 w-16 text-destructive" />
            </div>
          </div>
          
          <div className="space-y-2">
            <h1 className="text-3xl font-bold tracking-tight">Access Denied</h1>
            <p className="text-muted-foreground">
              This page is restricted to SmartLight employees only.
            </p>
          </div>

          <div className="space-y-3 pt-4">
            <p className="text-sm text-muted-foreground">
              If you believe you should have access to this page, please contact your administrator.
            </p>
          </div>
        </div>
      </div>
    );
  }

  // User is authenticated and is a SmartLight employee - render the protected content
  return children;
}

export { ProtectedRoute };
